if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations();
    }

    initializeRecommendations() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("product-recommendations");

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector(".card")) {
              this.classList.add("product-recommendations-loaded");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      // FNY 05.10.2026 (#869fc8kg4): load recommendations right after page load instead of
      // when the section is 200px from the viewport. Loading on scroll inserted ~860px of
      // content while the sections below were on screen and caused CLS 0.33-0.38 (desktop).
      // A huge bottom rootMargin makes the observer fire immediately, so the content arrives
      // while this area is still below the fold (off-screen shifts do not count as CLS).
      // Revert: set rootMargin back to "0px 0px 200px 0px".
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 100000px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
